export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00239.0605b4f3.png";